import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Error = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: 'var(--bg-primary)' }}>
      <div className="text-center max-w-lg">
        {/* Large 404 */}
        <h1 className="text-[120px] md:text-[160px] font-black leading-none tracking-tighter mb-4">
          <span className="gradient-text">4</span>
          <span style={{ color: 'var(--border-color)' }}>0</span>
          <span className="gradient-text-warm">4</span>
        </h1>

        <h2 className="headline mb-3" style={{ color: 'var(--text-primary)' }}>Page Not Found</h2>
        <p className="subheadline mb-8 max-w-sm mx-auto">
          The page you're looking for doesn't exist or has been moved. Let's get you back on track.
        </p>

        <Link to="/" className="btn-primary">
          Back to Home <FaArrowRight size={11} />
        </Link>
      </div>
    </div>
  );
};

export default Error;
